export interface User {
  Role: string;
  Email: string;
  WWID?: string;
}

export const users: User[] = [
  {
    "Role": "patoffhighway_view",
    "Email": "ronald.s.merkel@cummins.com",
    "WWID": "AT021@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "jason.cooper@cummins.com",
    "WWID": "FA503@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "mark.hansen@cummins.com",
    "WWID": "MX293@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "brian.breaux@cummins.com",
    "WWID": "JS614@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "chris.m.mcgough@cummins.com",
    "WWID": "BT786@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "Ryan.m.oneal@cummins.com",
    "WWID": "TL407@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "mathieu.bellavance@cummins.com",
    "WWID": "KH328@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "erick.lambert@cummins.com",
    "WWID": "BF771@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "michael.r.aufdermauer@cummins.com",
    "WWID": "CN862@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "benjamin.snodgress@cummins.com",
    "WWID": "JE532@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "michelle.curry@cummins.com",
    "WWID": "IB606@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "jessica.mcbrayer@cummins.com",
    "WWID": "JZ320@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "urja.shah@cummins.com",
    "WWID": "VW163@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "prajwal.kk@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "patoffhighway_view",
    "Email": "ravitheja.reddy@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "patoffhighway_view",
    "Email": "aditya.b@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "patoffhighway_view",
    "Email": "mounika.keerti@cummins.com",
    "WWID": "WF979@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "ankita.baishnab@simadvisorytech.com",
    "WWID": "aq66o@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "luke.hayward@cummins.com",
    "WWID": "pz521@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "anand.kumar3@cummins.com",
    "WWID": "vt981@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "vivek.bhagat@simadvisory.com",
    "WWID": "qp514@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "rachel.myslak@cummins.com",
    "WWID": "lr980@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "julie.e.bermudez@cummins.com",
    "WWID": "cv064@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "benjamin.schilling@cummins.com",
    "WWID": "jg893@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "josette.calleja@cummins.com",
    "WWID": "pl443@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "alan.rabadi@cummins.com",
    "WWID": "fw223@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "jordan.schantz@cummins.com",
    "WWID": "hi932@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "karyn.nummy@cummins.com",
    "WWID": "lo294@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "andrew.flegal@cummins.com",
    "WWID": "mj422@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "brian.pinkstaff@cummins.com",
    "WWID": "if042@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "mohor.gosavi@cummins.com",
    "WWID": "jg189@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "barry.r.warn@cummins.com",
    "WWID": "fc102@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "jill.moore@cummins.com",
    "WWID": "bv778@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "justin.phillips@cummins.com",
    "WWID": "lo703@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "richard.dorf@cummins.com",
    "WWID": "my297@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "nicholas.kryder@cummins.com",
    "WWID": "pl825@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "tomislav.t.budija@cummins.com",
    "WWID": "ch039@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "tom.lamano@cummins.com",
    "WWID": "bp762@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "johnny.mulfati@cummins.com",
    "WWID": "ah101@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "cory.w.abel@cummins.com",
    "WWID": "bv131@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "kevin.d.braun@cummins.com",
    "WWID": "kv155@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "sylvain.godbout@cummins.com",
    "WWID": "ll124@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "kedar.gokhale@cummins.com",
    "WWID": "hu276@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "arcy.wilson@cummins.com",
    "WWID": "cj722@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "joe.koenig@cummins.com",
    "WWID": "oy584@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "xiaoke.yang@cummins.com",
    "WWID": "qe048@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "rodney.f.shanks@cummins.com",
    "WWID": "gz030@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "carolina.peregrino@cummins.com",
    "WWID": "ob217@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "elizabeth.shores@cummins.com",
    "WWID": "lh611@cummins.com"
  },
  {
    "Role": "patoffhighway_view",
    "Email": "jennifer.ziegenhagen@cummins.com",
    "WWID": "ip323@cummins.com"
  }
]


export const getMappedRoleByEmail = (email?: string | null): string | null => {
    if (!email) {
        return null;
    }

    const normalizedEmail = normalizeIdentityValue(email);
    const matchedUser = users.find((user) => normalizeIdentityValue(user.Email) === normalizedEmail);

    return matchedUser?.Role ?? null;
};

export const getMappedRoleForUser = (identity?: {
    email?: string | null;
    wwid?: string | null;
    username?: string | null;
}): string | null => {
    if (!identity) {
        return null;
    }

    const normalizedEmail = normalizeIdentityValue(identity.email);
    const normalizedWwid = normalizeWwid(identity.wwid) || normalizeWwid(identity.username);
    const normalizedUsername = normalizeIdentityValue(identity.username);
    const normalizedUsernameLocalPart = normalizeEmailLocalPart(identity.username);
    const normalizedUsernameShortName = normalizeShortName(identity.username);

    const matchedUser = users.find((user) => {
        const userEmail = normalizeIdentityValue(user.Email);
        const userEmailLocalPart = normalizeEmailLocalPart(user.Email);
        const userEmailShortName = normalizeShortName(user.Email);
        const userWwid = normalizeWwid(user.WWID);

        return (
            (!!normalizedEmail && userEmail === normalizedEmail) ||
            (!!normalizedUsername && userEmail === normalizedUsername) ||
            (!!normalizedUsernameLocalPart && userEmailLocalPart === normalizedUsernameLocalPart) ||
            (!!normalizedUsernameShortName && userEmailShortName === normalizedUsernameShortName) ||
            (!!normalizedWwid && userWwid === normalizedWwid)
        );
    });

    return matchedUser?.Role ?? null;
};

const normalizeIdentityValue = (value?: string | null): string => (
    String(value || '').trim().toLowerCase()
);

const normalizeWwid = (value?: string | null): string => {
    const normalized = normalizeIdentityValue(value);
    if (!normalized) {
        return '';
    }

    return normalized.includes('@') ? normalized.split('@')[0] : normalized;
};

const normalizeEmailLocalPart = (value?: string | null): string => {
    const normalized = normalizeIdentityValue(value);
    if (!normalized) {
        return '';
    }

    return normalized.includes('@') ? normalized.split('@')[0] : normalized;
};

const normalizeShortName = (value?: string | null): string => {
    const localPart = normalizeEmailLocalPart(value);
    if (!localPart) {
        return '';
    }

    return localPart.split('.')[0];
};
